module.exports = __webpack_public_path__ + "img/H01120-74.2973b6e8.jpg";